import { defineComponent as _defineComponent } from 'vue'
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds'
import {
  TemplateEngineContext,
  type ImpactSolutionType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    impactGoal: null,
    impact: null,
    impactSolution: null
  },
  setup(__props: any) {



return { __sfc: true,IMPACT_SECTION_IDS, TemplateEngineContext }
}

})